import { render } from "./AllonlyNews.vue?vue&type=template&id=3a49751a&scoped=true"
import script from "./AllonlyNews.vue?vue&type=script&lang=js"
export * from "./AllonlyNews.vue?vue&type=script&lang=js"

import "./AllonlyNews.vue?vue&type=style&index=0&id=3a49751a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a49751a"]])

export default __exports__